
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/partner-program/background-check",
      function () {
        return require("private-next-pages/developers/partner-program/background-check.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/partner-program/background-check"])
      });
    }
  